var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlexa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47718 2 2 6.47723 2 12.0001C2 17.0708 5.7743 21.2594 10.6667 21.9114V19.8963C10.6667 19.3281 10.3084 18.8176 9.76975 18.6368C6.94695 17.6885 4.92754 14.9904 5.00192 11.8313C5.09247 7.9854 8.22534 4.96154 12.0722 5.00031C15.9049 5.03908 19 8.15811 19 12.0001C19 12.0876 18.9979 12.1748 18.9947 12.2614C18.9939 12.2808 18.9933 12.3004 18.9925 12.3199C18.9888 12.4004 18.9839 12.4808 18.9776 12.5606C18.9757 12.5861 18.9731 12.6114 18.9708 12.6368C18.9659 12.6926 18.9602 12.748 18.9539 12.8032C18.9468 12.866 18.9386 12.9285 18.9298 12.9906C18.926 13.019 18.9222 13.0475 18.9178 13.0757C18.0608 18.7212 10.7078 21.8942 10.6675 21.9115C11.1035 21.9695 11.5482 22 12 22C17.5228 22 22 17.5229 22 12.0001C22 6.47723 17.5228 2 12 2Z",
    fill: "#5FCAF4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13374_738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.47718 2 2 6.47723 2 12.0001C2 17.0708 5.7743 21.2594 10.6667 21.9114V19.8963C10.6667 19.3281 10.3084 18.8176 9.76975 18.6368C6.94695 17.6885 4.92754 14.9904 5.00192 11.8313C5.09247 7.9854 8.22534 4.96154 12.0722 5.00031C15.9049 5.03908 19 8.15811 19 12.0001C19 12.0876 18.9979 12.1748 18.9947 12.2614C18.9939 12.2808 18.9933 12.3004 18.9925 12.3199C18.9888 12.4004 18.9839 12.4808 18.9776 12.5606C18.9757 12.5861 18.9731 12.6114 18.9708 12.6368C18.9659 12.6926 18.9602 12.748 18.9539 12.8032C18.9468 12.866 18.9386 12.9285 18.9298 12.9906C18.926 13.019 18.9222 13.0475 18.9178 13.0757C18.0608 18.7212 10.7078 21.8942 10.6675 21.9115C11.1035 21.9695 11.5482 22 12 22C17.5228 22 22 17.5229 22 12.0001C22 6.47723 17.5228 2 12 2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13374_738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.482422 23.5175H23.519V0.482431H0.482422V23.5175Z",
    fill: "#5FCAF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlexa);
export default __webpack_public_path__ + "static/media/alexa.b2878adbc0951a99d0b9bf14bedc7092.svg";
export { ForwardRef as ReactComponent };